import { handleActions } from 'redux-actions';
import cloneDeep from 'lodash/cloneDeep';
import update from 'immutability-helper';
import {
  loading,
  fetchReports,
  updateReports,
  clearReports,
  deleteReport,
  updateProgress,
} from './actions';

export const initialState = {
  loading: false,
  reports: [],
  progress: 0,
};

export const reducer = handleActions(
  {
    [loading]: {
      next: state =>
        update(state, {
          loading: { $set: true },
        }),
    },

    [fetchReports]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          loading: { $set: false },
          reports: { $set: payload || [] },
        });
        return newState;
      },
      throw: state => {
        const newState = update(state, {
          loading: { $set: false },
          reports: { $set: [] },
        });
        return newState;
      },
    },

    [updateProgress]: {
      next: (state, { payload }) => {
        if (payload > state.progress) {
          return update(state, {
            progress: { $set: payload === 100 ? 0 : payload },
          });
        }
        return state;
      },
      throw: state => {
        return update(state, {
          progress: { $set: 0 },
        });
      },
    },

    [updateReports]: {
      next: (state, { payload }) => {
        const newState = update(state, {
          loading: { $set: false },
          reports: { $set: payload.reports || [] },
        });
        return newState;
      },
      throw: state => {
        const newState = update(state, {
          loading: { $set: false },
          reports: { $set: [] },
        });
        return newState;
      },
    },

    [clearReports]: {
      next: (state, { payload }) => {
        return update(state, {
          loading: { $set: false },
          reports: { $set: [] },
        });
      },
      throw: state => {
        return update(state, {
          loading: { $set: false },
          reports: { $set: [] },
        });
      },
    },

    [deleteReport]: {
      next: (state, { payload }) => {
        return update(state, {
          loading: { $set: false },
          reports: { $set: payload || [] },
        });
      },
      throw: state => {
        return update(state, {
          loading: { $set: false },
          reports: { $set: [] },
        });
      },
    },
  },
  cloneDeep(initialState)
);

export default reducer;
